<div>
  <label *ngIf="!showFile && !apiLoader" class="upload-field" (click)="showCAM()">
    <div class="flex justify-between items-center">
      <div>
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="50" height="50" rx="8" fill="#0B3275" fill-opacity="0.1" />
          <rect x="1" y="1" width="48" height="48" rx="7" stroke="#0B3275" stroke-opacity="0.4" stroke-width="2"
            stroke-dasharray="4 4" />
          <path
            d="M15.8604 19.2857C15.8604 18.6795 16.1012 18.0981 16.5298 17.6695C16.9585 17.2408 17.5399 17 18.1461 17H31.8604C32.4666 17 33.0479 17.2408 33.4766 17.6695C33.9053 18.0981 34.1461 18.6795 34.1461 19.2857V30.7143C34.1461 31.3205 33.9053 31.9019 33.4766 32.3305C33.0479 32.7592 32.4666 33 31.8604 33H18.1461C17.5399 33 16.9585 32.7592 16.5298 32.3305C16.1012 31.9019 15.8604 31.3205 15.8604 30.7143V19.2857ZM17.0032 29.5714V30.7143C17.0032 31.0174 17.1236 31.3081 17.3379 31.5224C17.5523 31.7367 17.843 31.8571 18.1461 31.8571H31.8604C32.1635 31.8571 32.4541 31.7367 32.6685 31.5224C32.8828 31.3081 33.0032 31.0174 33.0032 30.7143V26.7143L28.6866 24.4891C28.5795 24.4355 28.4581 24.4168 28.3398 24.4359C28.2214 24.455 28.1121 24.5108 28.0272 24.5954L23.7872 28.8354L20.7472 26.8103C20.6374 26.7372 20.5058 26.7043 20.3746 26.7173C20.2433 26.7302 20.1206 26.7881 20.0272 26.8811L17.0032 29.5714ZM22.7175 22.1429C22.7175 21.6882 22.5369 21.2522 22.2154 20.9307C21.8939 20.6092 21.4579 20.4286 21.0032 20.4286C20.5486 20.4286 20.1125 20.6092 19.791 20.9307C19.4695 21.2522 19.2889 21.6882 19.2889 22.1429C19.2889 22.5975 19.4695 23.0335 19.791 23.355C20.1125 23.6765 20.5486 23.8571 21.0032 23.8571C21.4579 23.8571 21.8939 23.6765 22.2154 23.355C22.5369 23.0335 22.7175 22.5975 22.7175 22.1429Z"
            fill="#0B3275" fill-opacity="0.5" />
        </svg>
      </div>

      <div>
        <div *ngIf="!loading" class="flex items-center">
          <div class="mr-[10px]">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M5.30039 6.00156C4.66387 6.00156 4.05342 6.25442 3.60333 6.70451C3.15325 7.15459 2.90039 7.76504 2.90039 8.40156V18.0016C2.90039 18.6381 3.15325 19.2485 3.60333 19.6986C4.05342 20.1487 4.66387 20.4016 5.30039 20.4016H19.7004C20.3369 20.4016 20.9474 20.1487 21.3974 19.6986C21.8475 19.2485 22.1004 18.6381 22.1004 18.0016V8.40156C22.1004 7.76504 21.8475 7.15459 21.3974 6.70451C20.9474 6.25442 20.3369 6.00156 19.7004 6.00156H17.7972C17.479 6.00149 17.1738 5.87502 16.9488 5.64996L15.6036 4.30476C15.1536 3.85464 14.5433 3.6017 13.9068 3.60156H11.094C10.4575 3.6017 9.84717 3.85464 9.39719 4.30476L8.05199 5.64996C7.827 5.87502 7.52182 6.00149 7.20359 6.00156H5.30039ZM12.5004 16.8016C12.9731 16.8016 13.4413 16.7084 13.8781 16.5275C14.3148 16.3466 14.7117 16.0814 15.046 15.7471C15.3803 15.4129 15.6454 15.016 15.8264 14.5792C16.0073 14.1425 16.1004 13.6743 16.1004 13.2016C16.1004 12.7288 16.0073 12.2607 15.8264 11.8239C15.6454 11.3871 15.3803 10.9903 15.046 10.656C14.7117 10.3217 14.3148 10.0565 13.8781 9.8756C13.4413 9.69468 12.9731 9.60156 12.5004 9.60156C11.5456 9.60156 10.6299 9.98085 9.95481 10.656C9.27968 11.3311 8.90039 12.2468 8.90039 13.2016C8.90039 14.1563 9.27968 15.072 9.95481 15.7471C10.6299 16.4223 11.5456 16.8016 12.5004 16.8016Z"
                fill="#0361F0" />
            </svg>
          </div>
          <p>Take Photo</p>
        </div>

        <div *ngIf="loading" class="flex items-center">
          <p>loading...</p>
        </div>
      </div>
    </div>

    <!-- <input
      #imageInput
      class="hidden"
      type="file"
      accept="image/*"
      (change)="processFile(imageInput)"
    > -->
  </label>

  <div *ngIf="showFile && !apiLoader" class="mt-3 flex justify-between items-center">
    <div class="flex items-center">
      <div class="mr-3">
        <img [src]="selectedFile?.src" class="image" />
      </div>

      <div>
        <p class="main-p">
          {{ selectedFile?.fileName }}
        </p>
        <p class="sub-p">
          {{ selectedFile?.fileSize }}
        </p>
      </div>
    </div>


    <div (click)="removeFile()">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M10.7996 2.40039C10.3451 2.40039 9.92957 2.65719 9.7263 3.06373L8.85797 4.80039H4.79961C4.13687 4.80039 3.59961 5.33765 3.59961 6.00039C3.59961 6.66313 4.13687 7.20039 4.79961 7.20039L4.79961 19.2004C4.79961 20.5259 5.87413 21.6004 7.19961 21.6004H16.7996C18.1251 21.6004 19.1996 20.5259 19.1996 19.2004V7.20039C19.8624 7.20039 20.3996 6.66313 20.3996 6.00039C20.3996 5.33765 19.8624 4.80039 19.1996 4.80039H15.1413L14.2729 3.06373C14.0697 2.65719 13.6541 2.40039 13.1996 2.40039H10.7996ZM8.39961 9.60039C8.39961 8.93765 8.93687 8.40039 9.59961 8.40039C10.2624 8.40039 10.7996 8.93765 10.7996 9.60039V16.8004C10.7996 17.4631 10.2624 18.0004 9.59961 18.0004C8.93687 18.0004 8.39961 17.4631 8.39961 16.8004V9.60039ZM14.3996 8.40039C13.7369 8.40039 13.1996 8.93765 13.1996 9.60039V16.8004C13.1996 17.4631 13.7369 18.0004 14.3996 18.0004C15.0624 18.0004 15.5996 17.4631 15.5996 16.8004V9.60039C15.5996 8.93765 15.0624 8.40039 14.3996 8.40039Z"
          fill="#E94444" />
      </svg>
    </div>
  </div>

  <div *ngIf="apiLoader" class="mt-3 flex justify-center items-center">
    <div>
      <ng-template #indicatorTemplate><i nz-icon nzType="loading"></i></ng-template>
      <nz-spin style="pointer-events: none" nzSimple [nzIndicator]="indicatorTemplate"> </nz-spin>
    </div>
  </div>
</div>
